// Remove boost-pfs-filter-loading-hidden class on page load
(function() {
    'use strict';
    
    // Function to remove the hidden class from loading elements
    function removeHiddenClass() {
        const loadingElements = document.querySelectorAll('.boost-pfs-filter-loading-hidden');
        loadingElements.forEach(function(element) {
            element.classList.remove('boost-pfs-filter-loading-hidden');
        });
    }
    
    // Remove the class immediately when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', removeHiddenClass);
    } else {
        removeHiddenClass();
    }
    
    // Also remove it after a short delay to catch any late-loading elements
    setTimeout(removeHiddenClass, 100);
    setTimeout(removeHiddenClass, 500);
    
    // Monitor for dynamically created loading elements with the hidden class
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1 && node.classList && node.classList.contains('boost-pfs-filter-loading-hidden')) {
                        node.classList.remove('boost-pfs-filter-loading-hidden');
                    }
                });
            }
            // Also check for class changes on existing elements
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const target = mutation.target;
                if (target.classList && target.classList.contains('boost-pfs-filter-loading-hidden')) {
                    target.classList.remove('boost-pfs-filter-loading-hidden');
                }
            }
        });
    });
    
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    });
    
})();
